var _circle, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUbbs(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 50,
    fill: "#002069"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_2144)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M33.0629 42V57.8192L33.2081 57.9626H35.9347L36.0799 57.8192V55.9423C36.4775 55.9111 36.6668 56.3476 36.9635 56.5596C42.4482 60.5066 51.6379 55.2128 48.3306 48.7966C46.2541 44.7623 40.0498 43.6586 36.6163 46.6142C36.4333 46.7763 36.4396 47.0818 36.0799 47.0008V42H33.0629ZM36.124 50.4614C36.4901 48.4723 38.9832 47.3624 40.8325 47.2253C44.247 46.9696 47.3081 49.9688 45.5977 53.2736C43.3697 57.5698 35.171 55.6555 36.1303 50.4614H36.124Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.0256 42L50.8805 42.1434V57.7256C50.8805 57.7256 51.1077 57.9688 51.1266 57.9688H53.9037V55.9984L54.0994 55.8987C57.7285 59.7958 65.7189 57.7631 66.7288 52.5066C67.6945 47.4934 62.0898 44.12 57.5833 45.1052C56.239 45.3983 54.9767 45.9906 54.0994 47.0507L53.9037 46.9509V42H51.0319H51.0256ZM58.7447 47.2253C65.5422 46.795 65.498 56.0359 58.8141 55.6617C52.5152 55.3063 52.0229 47.6555 58.7447 47.2253Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.645 55.3437C76.9851 55.8239 73.3433 55.9236 72.0494 54.608C71.8285 54.3835 71.7276 54.0405 71.4688 53.8348H68.8432C68.2436 53.8348 69.3923 55.8675 69.5753 56.092C71.494 58.4677 77.6604 58.3055 80.2797 57.3453C82.1606 56.6532 83.6564 54.6204 82.7034 52.6438C81.3211 49.7693 75.6407 50.7046 73.0972 50.0125C71.1721 49.4887 70.8566 48.0608 72.9015 47.456C74.9717 46.8449 78.6703 46.9634 79.9389 49.021H82.8107C82.3878 46.4209 79.535 45.1613 77.1113 44.9805C74.2459 44.7685 69.2029 44.887 68.6349 48.5347C67.8901 53.3297 76.2403 52.1824 78.8344 52.993C80.7089 53.5791 80.3239 54.8574 78.6387 55.3437H78.645Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17 44.9805V51.7584C17 55.8613 21.6011 58.4614 25.3944 57.8379C27.9632 57.4139 31.119 55.0195 31.119 52.2385V44.9805H28.3419C28.203 45.0678 28.2093 45.1738 28.1904 45.311C27.9001 47.7677 28.9604 52.7186 27.1869 54.5643C25.691 56.1169 22.0051 56.0234 20.7554 54.2026C20.484 53.8036 19.9159 52.3944 19.9159 51.9517V44.9805H17Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.8887 42.2868H21.3802V44.0203H23.0338V42.4302L22.8887 42.2868Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.6882 42.2868H25.1798V44.0203H26.8334V42.4302L26.6882 42.2868Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_2144"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 66,
    height: 16,
    fill: "white",
    transform: "translate(17 42)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUbbs);
export default __webpack_public_path__ + "static/media/ubbs.4cf7a2edbc5593403654a6183ee645ce.svg";
export { ForwardRef as ReactComponent };